import {Queries} from '../../api/queries';
import {useReportsContext} from '../../context/reports-context';
import SalesTable from '../sales/SalesTable';
import ReportsLayout from './ReportsLayout';
import {useQuery} from '@tanstack/react-query';

const SalesReport = () => {
	const {reportingPeriod} = useReportsContext();

	const {data: sales} = useQuery(Queries.sales(reportingPeriod.startDate, reportingPeriod.endDate));

	return (
		<ReportsLayout title='Sales Report'>
			<SalesTable sales={sales ?? []} />
		</ReportsLayout>
	);
};

export default SalesReport;
